import moment from 'moment';
import { INotificationItem, INotificationItemMenu, INotificationsGenerals } from '../app/model/notification/notification-item.model';

export const NOTIFICATIONS_MOCK: INotificationItem[] = [
  {
    id: 1,
    alreadyRead: false,
    title: 'Solicitud de modificación',
    user: 'Bárbara Olivares',
    sectionIsUser: true,
    type: "Admin",
    date: moment(new Date()).subtract(10, 'minutes').toDate(),
    reason: 'Solicitud de modificación en documento aprobado',
    path: ""
  },
  {
    id: 1,
    alreadyRead: false,
    title: 'Solicitud de aprobación de documento',
    user: 'John Doe Perez',
    sectionIsUser: true,
    type: "Admin",
    date: moment(new Date()).subtract(2, 'hours').toDate(),
    reason: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam quasi hic volupt...',
    path: ""

  },
  {
    id: 1,
    alreadyRead: false,
    title: 'Documento desactivado',
    user: 'Ricardo Jimenez',
    sectionIsUser: false,
    type: "Admin",
    date: moment(new Date()).subtract(6, 'days').toDate(),
    reason: 'Cambio de estado del documento pasa a ser desactivado',
    path: ""

  },
  {
    id: 1,
    alreadyRead: true,
    title: 'Solicitud de modificación',
    user: 'Victor Franco',
    sectionIsUser: false,
    type: "Admin",
    date: moment(new Date()).subtract(6, 'days').toDate(),
    reason: 'Solicitud de modificación en documento aprobado',
    path: ""

  },
  {
    id: 1,
    alreadyRead: true,
    title: 'Solicita aprobación de documento',
    user: 'Borja Raúl',
    sectionIsUser: false,
    type: "Admin",
    date: moment(new Date()).subtract(6, 'days').toDate(),
    reason: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam quasi hic volupt...',
    path: ""

  },
  {
    id: 1,
    alreadyRead: true,
    title: 'Solicita aprobación de documento',
    user: 'Rómulo Daniel',
    sectionIsUser: false,
    type: "Admin",
    date: moment(new Date()).subtract(7, 'days').toDate(),
    reason: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam quasi hic voluptatem reiciendis! Hic alias suscipit excepturi aperiam illo tempora at sint, accusamus sunt sit atque nisi vero possimus dolorem?',
    path: ""

  },
  {
    id: 1,
    alreadyRead: true,
    title: 'Solicita aprobación de documento',
    user: 'Baldomero Floro',
    sectionIsUser: false,
    type: "Admin",
    date: moment(new Date()).subtract(8, 'days').toDate(),
    reason: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam quasi hic volupt...',
    path: ""

  },
  {
    id: 1,
    alreadyRead: true,
    title: 'Solicita aprobación de documento',
    user: 'Abigaíl María de los Ángeles',
    sectionIsUser: false,
    type: "Admin",
    date: moment(new Date()).subtract(9, 'days').toDate(),
    reason: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam quasi hic volupt...',
    path: ""

  },
  {
    id: 1,
    alreadyRead: true,
    title: 'Solicita aprobación de documento',
    user: 'Severiano Renato',
    sectionIsUser: false,
    type: "Admin",
    date: moment(new Date()).subtract(10, 'days').toDate(),
    reason: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam quasi hic volupt...',
    path: ""

  },
  {
    id: 1,
    alreadyRead: true,
    title: 'Solicita aprobación de documento',
    user: 'Julia Rafaela',
    sectionIsUser: false,
    type: "Admin",
    date: moment(new Date()).subtract(12, 'days').toDate(),
    reason: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam quasi hic volupt...',
    path: ""

  },
  {
    id: 1,
    alreadyRead: true,
    title: 'Solicita aprobación de documento',
    user: 'Paloma Vinicio',
    sectionIsUser: false,
    type: "Admin",
    date: moment(new Date()).subtract(13, 'days').toDate(),
    reason: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam quasi hic volupt...',
    path: ""

  },
  {
    id: 1,
    alreadyRead: true,
    title: 'Solicita aprobación de documento',
    user: 'Chucho Nicolás',
    sectionIsUser: false,
    type: "Admin",
    date: moment(new Date()).subtract(14, 'days').toDate(),
    reason: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam quasi hic volupt...',
    path: ""

  },
];

export const ALL_NOTIFICATIONS_MOCK: INotificationItemMenu[] = [
  {
    "id": 2,
    "documentId": 25,
    "messageId": 1,
    "description": "Hubo un cambio en solicitud de aprobación de documento",
    "notifiderId": 80,
    "read": false,
    "feCreation": new Date("2023-03-27T00:00:00"),
    "dateNotification": "27 March",
    pathNotification: "",

  },
  {
    "id": 3,
    "documentId": 24,
    "messageId": 2,
    "description": "Solicitud de modificación en documento aprobado",
    "notifiderId": 79,
    "read": false,
    "feCreation": new Date("2023-03-24T16:00:00"),
    "dateNotification": "24 March",
    pathNotification: "",

  },
  {
    "id": 4,
    "documentId": 68,
    "messageId": 3,
    "description": "Solicitud aprobación de documento",
    "notifiderId": 82,
    "read": true,
    "feCreation": new Date("2023-03-27T15:00:00"),
    "dateNotification": "27 March",
    pathNotification: "",

  },
  {
    "id": 5,
    "documentId": 69,
    "messageId": 4,
    "description": "Solicitud de eliminación de documento",
    "notifiderId": 83,
    "read": true,
    "feCreation": new Date("2023-03-24T17:00:00"),
    "dateNotification": "24 March",
    pathNotification: "",

  }
]

export const NOT_READ_NOTIFICATIONS_MOCK: INotificationItemMenu[] = [
  {
    "id": 2,
    "documentId": 25,
    "messageId": 1,
    "description": "Hubo un cambio en solicitud de aprobación de documento",
    "notifiderId": 80,
    "read": false,
    "feCreation": new Date("2023-03-27T00:00:00"),
    "dateNotification": "27 March",
    pathNotification: "",

  },
  {
    "id": 3,
    "documentId": 24,
    "messageId": 2,
    "description": "Solicitud de modificación en documento aprobado",
    "notifiderId": 79,
    "read": false,
    "feCreation": new Date("2023-03-24T16:00:00"),
    "dateNotification": "24 March",
    pathNotification: "",

  }
]

export const BUILD_NOTIFICATIONS_MOCK: INotificationItem[] = [
  {
    id: 2,
    "alreadyRead": false,
    "title": "Hubo un cambio en solicitud de aprobación de documento",
    "date": new Date("2023-03-27T00:00:00"),
    path: ""

  },
  {
    id: 3,
    "alreadyRead": false,
    "title": "Solicitud de modificación en documento aprobado",
    "date": new Date("2023-03-24T16:00:00"),
    path: ""

  }
]

export const NOTIFICATION_GENERAL: INotificationsGenerals[] = [
  {
    "id": 2,
    "messageId": 1,
    "sender": "admin",
    "notifiderId": 80,
    "read": false,
    "sectionIsUser": true,
    "feCreation": new Date("2023-03-27T00:00:00"),
    "pathNotification": "/libraries/admin/doc-approval/detail/24/139",
    "type": "Bibliotecas",
    "details": "Hubo un cambio en solicitud de aprobación de documento",
  },
  {
    "id": 3,
    "messageId": 2,
    "sender": "admin",
    "notifiderId": 79,
    "read": false,
    "sectionIsUser": true,
    "feCreation": new Date("2023-03-24T16:00:00"),
    "pathNotification": "/libraries/admin/adtve-docs/detail/25/58",
    "type": "Bibliotecas",
    "details": "Solicitud de modificación en documento aprobado"
  },
  {
    "id": 4,
    "messageId": 3,
    "sender": "admin",
    "notifiderId": 82,
    "read": false,
    "sectionIsUser": true,
    "feCreation": new Date("2023-03-27T15:00:00"),
    "pathNotification": "/libraries/admin/adtve-docs/detail/68/115",
    "type": "Bibliotecas",
    "details": "Solicitud aprobación de documento"
  },
  {
    "id": 5,
    "messageId": 4,
    "sender": "admin",
    "notifiderId": 83,
    "read": false,
    "sectionIsUser": true,
    "feCreation": new Date("2023-03-24T17:00:00"),
    "pathNotification": "/libraries/admin/adtve-docs/detail/69/116",
    "type": "Bibliotecas",
    "details": "Solicitud de eliminación de documento"
  }
];

export const BUILD_NOTIFICATION_GENERAL: INotificationItem[] = [
  {
      "id": 2,
      "alreadyRead": false,
      "title": "admin",
      "date": new Date("2023-03-27T00:00:00"),
      "sectionIsUser": true,
      "type": "Bibliotecas",
      "user": "admin",
      "reason": "Hubo un cambio en solicitud de aprobación de documento",
      "path": "/libraries/admin/doc-approval/detail/24/139"
  },
  {
      "id": 3,
      "alreadyRead": false,
      "title": "admin",
      "date": new Date("2023-03-24T16:00:00"),
      "sectionIsUser": true,
      "type": "Bibliotecas",
      "user": "admin",
      "reason": "Solicitud de modificación en documento aprobado",
      "path": "/libraries/admin/adtve-docs/detail/25/58"
  },
  {
      "id": 4,
      "alreadyRead": false,
      "title": "admin",
      "date": new Date("2023-03-27T15:00:00"),
      "sectionIsUser": true,
      "type": "Bibliotecas",
      "user": "admin",
      "reason": "Solicitud aprobación de documento",
      "path": "/libraries/admin/adtve-docs/detail/68/115"
  },
  {
      "id": 5,
      "alreadyRead": false,
      "title": "admin",
      "date": new Date("2023-03-24T17:00:00"),
      "sectionIsUser": true,
      "type": "Bibliotecas",
      "user": "admin",
      "reason": "Solicitud de eliminación de documento",
      "path": "/libraries/admin/adtve-docs/detail/69/116"
  }
]

export const MOCK_NOTIFICATIONS_TEMPLATE = {
  "list": [
    {
        "id": 1,
        "channelId": 3,
        "channelName": "SMS",
        "name": "Aprobacion Test",
        "messageText": "Se ha aprobado un documento",
        "url": null,
        "creationDate": "29/08/2023",
        "updateDate": "",
        "status": true
    },
    {
        "id": 2,
        "channelId": 3,
        "channelName": "SMS",
        "name": "Aprobacion Test2",
        "messageText": "Se ha aprobado un documento",
        "url": null,
        "creationDate": "30/08/2023",
        "updateDate": "",
        "status": true
    }
  ],
  "size": 10,
  "total": 2,
  "page": 1
}

export const MOCK_CATALOG_SERVICE = [
  {
    id: 1,
    name: "Servicio 1"
  },
  {
    id: 2,
    name: "Servicio 2"
  },
  {
    id: 3,
    name: "Servicio 3"
  },
]

export const MOCK_CATALOG_CHANEL = [
  {
    id: 1,
    name: "Whatsapp"
  },
  {
    id: 2,
    name: "Email"
  },
  {
    id: 3,
    name: "Teams"
  },
]

export const MOCK_CATALOG_PARAMS = [
  {
    id: 1,
    name: "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa"
  },
  {
    id: 2,
    name: "Peticion"
  },
  {
    id: 3,
    name: "Solicitud"
  },
  {
    id: 4,
    name: "Mensaje2"
  },
  {
    id: 5,
    name: "Peticion2"
  },
  {
    id: 6,
    name: "Solicitud2"
  },
  {
    id: 7,
    name: "Mensaje3"
  },
  {
    id: 8,
    name: "Peticion3"
  },
  {
    id: 9,
    name: "Solicitud3"
  },
  {
    id: 10,
    name: "Mensaje4"
  },
  {
    id: 11,
    name: "Peticion4"
  },
  {
    id: 12,
    name: "Solicitud4"
  },
  {
    id: 13,
    name: "Mensaje5"
  },
  {
    id: 14,
    name: "Peticion5"
  },
  {
    id: 15,
    name: "Solicitud5"
  },
]
export const MOCK_NOTIFICATIONS_TRANSACTIONAL = {
  "countPage": 1,
  "total": 3,
  "page": 1,
  "size": 10,
  "data": [
    {
      "id": 4,
      "templateId": 1,
      "transactionalServicesId": 1,
      "name": "strinaaaaaaaaaaaaaaaaag",
      "transactionalName": "strinaaaaaaaaaaaaaaaaag",
      "serviceName": "Asignación de expedientes al alumno",
      "channelName": "SMS",
      "feUpdate": "2023-08-30T10:29:30.197",
      "status": false
  }
  ]
}

export const MOCK_NOTIFICATIONS_TRANSACTIONAL_JOIN= [
  {
      "id": 1,
      "serviceName": "Nuevo Tutor",
      "transactionalServicesId": 1035,
      "status": true
  }
]